import { FieldErrors } from 'react-hook-form';
import type { StudyFormValues } from '../types/study-edit.interface';
import { flattenErrors } from '@/shared/utils/errors/flattenErrors';

export type CrossQuestionnaireError = {
  path: string;
  message: string;
  emaIndex: number;
  questionIndex: number;
  conditionIndex: number;
};

type ConditionErrorType = {
  message?: string;
};

type QuestionErrorType = {
  displayConditions?: {
    conditions?: ConditionErrorType[];
  };
};

const extractCrossQuestionnaireErrors = (
  errors: FieldErrors<StudyFormValues>,
): CrossQuestionnaireError[] => {
  const crossErrors: CrossQuestionnaireError[] = [];

  if (!errors.emaQuestionnaires || !Array.isArray(errors.emaQuestionnaires)) {
    return crossErrors;
  }

  errors.emaQuestionnaires.forEach((emaError, emaIndex) => {
    if (!emaError?.questions || !Array.isArray(emaError.questions)) {
      return;
    }

    emaError.questions.forEach(
      (questionError: QuestionErrorType, questionIndex: number) => {
        const conditions = questionError?.displayConditions?.conditions;
        if (!conditions || !Array.isArray(conditions)) {
          return;
        }

        conditions.forEach(
          (conditionError: ConditionErrorType, conditionIndex: number) => {
            if (conditionError === undefined) {
              return;
            }

            const message =
              conditionError?.message ?? flattenErrors(conditionError)[0];

            crossErrors.push({
              path: `emaQuestionnaires[${emaIndex}].questions[${questionIndex}].displayConditions.conditions[${conditionIndex}]`,
              message,
              emaIndex,
              questionIndex,
              conditionIndex,
            });
          },
        );
      },
    );
  });

  return crossErrors;
};

export const getQuestionnaireErrors = (
  errors: FieldErrors<StudyFormValues>,
  questionnaireIndex: number,
): CrossQuestionnaireError[] => {
  const allErrors = extractCrossQuestionnaireErrors(errors);
  return allErrors.filter((error) => error.emaIndex === questionnaireIndex);
};
